import { T } from '@/libs/translation';
import { z } from 'zod';

export const REFRESH_TOKEN_EXPIRE_DURATION = { days: 180 };
export const ACCESS_TOKEN_EXPIRE_DURATION = { days: 1 };
export const USER_TYPE = {
  NEED_VERIFY2: 'NEED_VERIFY2',
  NEED_VERIFY: 'NEED_VERIFY',
  CUSTOMER: 'CUSTOMER',
} as const;

export const USER_AUTHORIZATION_CODE_EXPIRE_DURATION = { days: 7 };
export const APP_USER_AUTHORIZATION_CODE_EXPIRE_DURATION = { years: 1 };

export const USER_LOGIN_SNS_TYPE_MAPPER = {
  KAKAO: 'KAKAO',
  NAVER: 'NAVER',
  GOOGLE: 'GOOGLE',
  APPLE: 'APPLE',
  FACEBOOK: 'FACEBOOK',
} as const;

export const USER_LOGIN_TYPE_MAPPER = {
  EMAIL: 'EMAIL',
  ...USER_LOGIN_SNS_TYPE_MAPPER,
} as const;

export const USER_GENDER_MAPPER = {
  FEMALE: 'FEMALE',
  MALE: 'MALE',
  WHATEVER: 'WHATEVER',
} as const;

export const USER_GENDER_NAME_MAPPER = {
  MALE: T('user.gender.001'),
  FEMALE: T('user.gender.002'),
  WHATEVER: T('user.gender.003'),
} as const;

export const USER_AGREEMENT_TYPE_MAPPER = {
  MARKETING: 'MARKETING',
  APP_PUSH: 'APP_PUSH',
  SMS: 'SMS',
  EMAIL: 'EMAIL',
} as const;

export const USER_AGREEMENT_TYPE_ENUM = z.nativeEnum(USER_AGREEMENT_TYPE_MAPPER);
export const USER_TYPE_ENUM = z.nativeEnum(USER_TYPE);
